/**
 * @returns {void}
 */
module.exports = function hideForm1262Form() {
    document.querySelectorAll('[data-component="form1262-step-form"]').forEach(form1262 => {
        if (form1262 instanceof Element) {
            form1262.style.display = 'none';
        }
    });
};